// @ts-nocheck - Class component types incompatible with React 18 + TS5
import './LabeledText.scss';

import { mdiInformation } from '@mdi/js';
import { Tooltip } from 'antd';
import Icon from 'components/Icon/Icon';
import { truncateTextInMiddle } from 'helpers/textHelper';
import React from 'react';
import ReactLinkify from 'react-linkify';

interface Props {
  label: string;
  value?: any;
  children?: any;
  disableLinkify?: boolean;
  tooltip?: string;
}

const LabeledText = (props: Props) => {
  return (
    <div className="LabeledText">
      <div className="LabeledText_label">
        {props.label}
        {props.tooltip && (
          <Tooltip
            title={props.tooltip}
            classNames={{ root: 'LabeledText_tooltip' }}
            className="LabeledText_tooltip"
          >
            <span>
              <Icon path={mdiInformation} />
            </span>
          </Tooltip>
        )}
      </div>
      <div className="LabeledText_value">
        <ReactLinkify
          componentDecorator={(decoratedHref, decoratedText, key) => {
            if (props.disableLinkify) {
              return decoratedText;
            }

            const url = new URL(decoratedHref);

            if (url.protocol === 'mailto:' || url.protocol === 'tel:') {
              return (
                <a target="blank" href={decoratedHref} key={key}>
                  {decoratedText}
                </a>
              );
            }

            const mergedPathWithQuery = url.pathname + url.search;
            // remove trailing slash if it's just the root path
            const cleanPath = mergedPathWithQuery === '/' ? '' : mergedPathWithQuery;
            const truncate = cleanPath ? truncateTextInMiddle(cleanPath, 15) : '';

            return (
              <a target="blank" href={decoratedHref} key={key}>
                {`${url.hostname}${truncate}`}
              </a>
            );
          }}
        >
          {props.value === 0 ? props.value : props.value || props.children}
        </ReactLinkify>
      </div>
    </div>
  );
};

export default LabeledText;
